<template>
    <div class="sort-wrapper">
        <sort-box @sortClick="openSort = !openSort" :param="names[filterParam]" :open="openSort"/>
        <!--<div class="mobile-filter-box">
                             <span class="mobile-filter-btn" @click.prevent="mobileFilterClick">
                                 <icon-base width="15" height="15" viewBox="0 0 15 15" ><icon-filter-mobile/></icon-base>
                                 <span>Filter</span>
                             </span>
                     </div>-->
    </div>
    <div class="filter-result-items">
        <div class="item">
            <div class="item-icon-close">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z"
                          fill="white"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                          fill="white"></path>
                </svg>
            </div>
            <div class="item-box">
                <p class="item-title">Company:</p>
                <div class="item-result">France Televisions</div>
            </div>
        </div>
        <div class="item">
            <div class="item-icon-close">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z"
                          fill="white"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                          fill="white"></path>
                </svg>
            </div>
            <div class="item-box">
                <p class="item-title">LX Terminal:</p>
                <p class="item-result">Cobham 6075 LX</p>
            </div>
        </div>
        <div class="item">
            <div class="item-icon-close">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z"
                          fill="white"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                          fill="white"></path>
                </svg>
            </div>
            <div class="item-box">
                <p class="item-title">Event date:</p>
                <div class="item-result">
                    <div class="date-time-block">
                        <span class="date">09.01.2020</span>
                        <span class="time">10:00 pm</span>
                    </div>
                    <div class="date-time-block">
                        <span class="date">09.10.2020</span>
                        <span class="time">12:00 am</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="item-icon-close">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z"
                          fill="white"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                          fill="white"></path>
                </svg>
            </div>
            <div class="item-box">
                <p class="item-title">Location:</p>
                <p class="item-result">France, Paris</p>
            </div>
        </div>
        <div class="item">
            <div class="item-icon-close">
                <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M11.2075 12.5L0 1.29249L0.79249 0.5L12 11.7075L11.2075 12.5Z"
                          fill="white"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M4.63779e-07 11.7075L11.2075 0.5L12 1.29249L0.792492 12.5L4.63779e-07 11.7075Z"
                          fill="white"></path>
                </svg>
            </div>
            <div class="item-box">
                <p class="item-title">Date of creation:</p>
                <div class="item-result">
                    <div class="date-time-block">
                        <span class="date">09.01.2020</span>
                        <span class="time">10:00 pm</span>
                    </div>
                    <div class="date-time-block">
                        <span class="date">09.10.2020</span>
                        <span class="time">12:00 am</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="table-box">
        <div class="table requests-past-table">
            <div class="table-head" :style="openSort ? 'display: flex;' : ''">
                <simple-table-filter name="status" label="Status" @filter="filterClick" :param="filterParam" class="status-col" :status="true"/>
                <simple-table-filter name="client_id" label="Company" @filter="filterClick" :param="filterParam" class="company-col"/>
                <simple-table-filter name="terminal_id" label="Terminal" @filter="filterClick" :param="filterParam" class="terminal-col"/>
                <simple-table-filter name="start_time" label="Start time (GMT+1)" @filter="filterClick" :param="filterParam" class="date-col"/>
                <simple-table-filter name="finish_time" label="Finish time (GMT+1)" @filter="filterClick" :param="filterParam" class="time-col"/>
                <simple-table-filter name="location" label="Location" @filter="filterClick" :param="filterParam" class="location-col"/>
                <simple-table-filter name="billing" label="Billing Ticket Nb" @filter="filterClick" :param="filterParam" class="ticket-col"/>
                <simple-table-filter name="created_at" label="Created" @filter="filterClick" :param="filterParam" class="creaded-col"/>
            </div>

            <div class="table-body" :class="loading ? 'loading' : ''">
                <div v-for="(request, index) of pastRequests" v-bind:key="index" class="row">
                    <event-status :status="request.status" :status-title="request.status_text"/>
                    <div class="col company-col"><p>{{request.company}}</p></div>
                    <div class="col terminal-col">
                        <div class="col-wrap">
                            <icon-base width="20" height="20" viewBox="0 0 15 15"><icon-sattellite/></icon-base>
                            <p>{{request.terminal_name}}</p></div>
                    </div>
                    <div class="col date-col">
                        <div class="col-wrap">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-calendar/></icon-base>
                            <p>{{formatDate(request.start_time)}}</p></div>
                    </div>
                    <div class="col time-col">
                        <div class="col-wrap">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-calendar/></icon-base>
                            <div class="time-wrap"><p>{{formatDate(request.finish_time)}}</p></div>
                        </div>
                    </div>
                    <div class="col location-col">
                        <div class="col-wrap">
                            <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-location/></icon-base>
                            <p>{{request.location}}</p></div>
                    </div>
                    <div class="col ticket-col">
                        <div class="col-wrap">
                            <!--<icon-base width="20" height="21" viewBox="0 0 20 21"><icon-calendar/></icon-base>
                            <div class="time-wrap"><p>{{formatDate(request.finish_time)}}</p></div>-->
                        </div>
                    </div>
                    <div class="col creaded-col"><p class="title">Creaded:</p>
                        <p class="creaded-col-date">{{formatDateShort(request.created_at)}}</p>
                        <p class="creaded-col-time">{{formatTime(request.created_at)}}</p>
                    </div>

                </div>
            </div>
        </div>

        <a href="#" v-if="loadMorePastRequests" class="js-show-more" @click.prevent="loadMore">Show more</a>
    </div>
</template>

<script>

    import moment from "moment"
    import {mapState, mapActions, mapMutations} from "vuex"
    import IconBase from "../../common/IconBase";
    import IconSattellite from "../../common/icons/IconSattelite";
    import IconCalendar from "../../common/icons/IconCalendar";
    import IconLocation from "../../common/icons/IconLocation";
    import EventStatus from "../../Client/EventStatus";
    import SortBox from "../SortBox";
    import SimpleTableFilter from "../../common/SimpleTableFilter";

    export default {
    name: 'past-and-canceled-requests',

    components: {
        SimpleTableFilter,
        SortBox,
        EventStatus,
        IconLocation,
        IconCalendar,
        IconSattellite,
        IconBase
    },

    data() {
        return {
            loading: false,
            currentPage: 1,
            filterIndex: 0,
            orderBy: true,
            sort: false,
            filterParam: 'created_at',
            openSort: false,
            names : {
                '0' : '',
                'status' : 'Status',
                'client_id' : 'Company',
                'terminal_id' : 'Terminal',
                'start_time' : 'Start time',
                'finish_time': 'Finish time',
                'location' : 'Location',
                'created_at' : 'Created',
            }
        }
    },

    computed: {
        ...mapState('requests', [
            'pastRequests',
            'loadMorePastRequests'
        ])
    },

    mounted() {
        this.loading = true;
        this.loadRequests({active: 0,sort: !this.order ? '-' + this.filterParam : this.filterParam}).then(() => {
            this.loading = false;
        });
    },


    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapActions('requests', [
            'loadRequests',
            'denyRequest'
        ]),
        ...mapMutations('requests', [
            'resetPast'
        ]),
        formatDate(date) {
            return moment(date).format('MMM D YYYY, h:mm a');
        },
        formatDateShort(date) {
            return moment(date).format('DD.MM.YY');
        },
        formatTime(date) {
            return moment(date).format('h:mm a');
        },
        getFilterClass(index) {
            if (index !== this.filterIndex) {
                return '';
            }

            return this.orderBy ? 'filter-up' : 'filter-down'
        },
        filterClick(value) {
            this.filterParam = value.name;
            this.order = value.order;
            this.openSort = false;

            if (this.filterParam) {
                this.loading = true;
                this.resetPast();
                this.currentPage = 1;
                this.loadRequests({active: 0, sort: !this.order ? '-' + this.filterParam : this.filterParam}).then(() => {
                    this.loading = false;
                });
            }
        },
        loadMore() {
            this.loading = true;
            this.currentPage += 1;
            this.loadRequests({active: 0, sort: !this.order ? '-' + this.filterParam : this.filterParam, page: this.currentPage}).then(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
